import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ["accordion", "unreadIndicator"]

    toggleAccordion(event) {
        const accordion = event.currentTarget.closest('[data-messages-my-list-target="accordion"]')
        const messageId = accordion.dataset.messageId
        const isRead = accordion.dataset.messageRead === 'true'
        const isReceiver = accordion.dataset.isReceiver === 'true'

        accordion.classList.toggle('is-open')

        if (!isRead && isReceiver) {
            this.markAsRead(messageId, accordion)
        }
    }

    async markAsRead(messageId, accordion) {
        try {
            const formData = new FormData();
            formData.append('message_id', messageId);

            const response = await fetch('/wp-json/api/dashboard/messages/actions/mark-as-read', {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.messages && data.messages['success-message']) {
                const unreadIndicator = accordion.querySelector('[data-messages-my-list-target="unreadIndicator"]');
                if (unreadIndicator) {
                    unreadIndicator.remove();
                }
                accordion.dataset.messageRead = 'true';
            }
        } catch (error) {
            console.error('Error marking message as read:', error);
        }
    }
}
